import CustomNode from './CustomNode';
import GroupNode from './GroupNode';
import CustomEdge from './CustomEdge';

// 直接导出静态对象，确保引用稳定
// CustomNode 和 GroupNode 已经在各自文件中 memo 过
// CustomEdge 也应该在其文件内 memo，而不是在这里
export const nodeTypes = Object.freeze({
  aiNode: CustomNode,
  group: GroupNode,
});

export const edgeTypes = Object.freeze({
  custom: CustomEdge,
});
